export default "__VITE_PUBLIC_ASSET__462947e4__"